import React, { lazy, Suspense } from "react";

import DefaultLoader from "../../utilities/loaders/DefaultLoader";
const MyRequestsContent = lazy(() => import("./MyRequestsContent"));

const MyRequests = () => {
  return (
    <Suspense fallback={<DefaultLoader />}>
      <MyRequestsContent />
    </Suspense>
  );
};

export default MyRequests;
